'use client'
import { Media } from '@/payload-types'
import VideoComponent from './CMVideoComponent'
import MuxVideoPlayer from './MuxPlayer'
import { getVideoSource, VideoSource } from './getVideoSource'

export { getVideoSource, VideoSource }

const VideoWrapper = ({
  mediaData,
  embeddedVideo,
  timeStamp,
}: {
  mediaData: Media
  embeddedVideo?: boolean
  timeStamp?: string | null
}) => {
  if (!mediaData) return null
  const videoSource = getVideoSource(mediaData)
  switch (videoSource) {
    case VideoSource.MUX:
      return (
        <MuxVideoPlayer
          videoData={mediaData}
          timeStamp={timeStamp}
        />
      )   
       case VideoSource.CUSTOM:
      return (
        <VideoComponent videoData={mediaData} embeddedVideo={embeddedVideo} timeStamp={timeStamp} />
      )
    default:
      return null
  }
}

export default VideoWrapper
